import { createContext, useState, useRef } from "react";
import moment from "moment";
import useAuth from "../hooks/useAuth";
import useGlobalParams from "../hooks/useGlobalParams";

const SPQSContext = createContext({});

export const SPQSProvider = ({ children }) => {
  // Load context values
  const { auth } = useAuth();
  const { globalparams } = useGlobalParams();

  const SPQSInit = {
    QSDate: moment().format("yyyy-MM-DD"),
    trader: auth.userCode,
    quantity: "0.00",
    tolerance: Number(globalparams?.Tolerance * 100).toFixed(2) + "%",
    numpallets: "0.00",
    materialcost: "$0.00",
    pcomission: "$0.00",
    pfinancecost: "$0.00",
    scomission: "$0.00",
    sfinancecost: "$0.00",
    outpayload: "0.00",
    outdrayage: "$0.00",
    loading: "$0.00",
    outcollectcharges: "$0.00",
    outboundothers: "$0.00",
    oceanfreight: "$0.00",
    oceanpayload: "0.00",
    generaldutyimp: "0.00%",
    additionaldutyimp: "0.00%",
    harborfeepct: Number(globalparams.HarborFeePct * 100).toFixed(4) + "%",
    merchprocfeepct: Number(globalparams.MerchProcFeePct * 100).toFixed(4) + "%",
    merchprocfee: "$0.00",
    flatfee: "$0.00",
    tsca: "$0.00",
    isf: "$0.00",
    inpayload: "0.00",
    indrayage: "$0.00",
    unloading: "$0.00",
    incollectcharges: "$0.00",
    inboundothers: "$0.00",
    inspectioncost: "$0.00",
    legal: "$" + Number(globalparams.Legal).toFixed(2),
    pallets: "$0.00",
    other: "$0.00",
    insurancerate: "0.00%",
    insurancefactor: "0.00",
    pinterest: Number(globalparams?.InterestRate * 100).toFixed(2) + "%",
    sinterest: Number(globalparams?.InterestRate * 100).toFixed(2) + "%",
    interestcost: "$0.00",
    salesprice: "$0.00",
    sold: 0,
  };
  const SPQSDataInit = {
    QSDate: moment().format("yyyy-MM-DD"),
    traderID: auth.userID,
    quantity: 0,
    tolerance: globalparams.Tolerance,
    numpallets: 0,
    materialcost: 0,
    pcomission: 0,
    pfinancecost: 0,
    scomission: 0,
    sfinancecost: 0,
    outpayload: 0,
    outdrayage: 0,
    loading: 0,
    outcollectcharges: 0,
    outboundothers: 0,
    oceanfreight: 0,
    oceanpayload: 0,
    generaldutyimp: 0,
    additionaldutyimp: 0,
    harborfeepct: globalparams.HarborFeePct,
    merchprocfeepct: globalparams.MerchProcFeePct,
    flatfee: 0,
    tsca: 0,
    isf: 0,
    inpayload: 0,
    indrayage: 0,
    unloading: 0,
    incollectcharges: 0,
    inboundothers: 0,
    inspectioncost: 0,
    legal: globalparams.Legal,
    pallets: 0,
    other: 0,
    insurancerate: 0,
    insurancefactor: 0,
    pinterest: globalparams?.InterestRate,
    sinterest: globalparams?.InterestRate,
    interestcost: 0,
    salesprice: 0,
    sold: 0,
  };

  const ppaytermInitSPQS = [{ row: 0, portion: "100.00%", payType: "PP", termdays: "20", type: "new" }];
  const ppaytermDataInitSPQS = [{ row: 0, portion: 1, payTypeID: 3, termdays: 20, type: "new" }];
  const ppayrowSPQS = useRef(0);
  const spaytermInitSPQS = [{ row: 0, portion: "100.00%", payType: "CAD", termdays: "10", type: "new" }];
  const spaytermDataInitSPQS = [{ row: 0, portion: 1, payTypeID: 1, termdays: 10, type: "new" }];
  const spayrowSPQS = useRef(0);
  const [SPQS, setSPQS] = useState(SPQSInit);
  const [SPQSData, setSPQSData] = useState(SPQSDataInit);
  const [ppaymenttermSPQS, setPpaymenttermSPQS] = useState(ppaytermInitSPQS);
  const [ppaymenttermDataSPQS, setPpaymenttermDataSPQS] = useState(ppaytermDataInitSPQS);
  const [spaymenttermSPQS, setSpaymenttermSPQS] = useState(spaytermInitSPQS);
  const [spaymenttermDataSPQS, setSpaymenttermDataSPQS] = useState(spaytermDataInitSPQS);
  const [qstoeditSP, setQstoeditSP] = useState();
  const [whdataSP, setWhdataSP] = useState();

  return (
    <SPQSContext.Provider
      value={{
        SPQSInit,
        SPQSDataInit,
        ppaytermInitSPQS,
        ppaytermDataInitSPQS,
        ppayrowSPQS,
        spaytermInitSPQS,
        spaytermDataInitSPQS,
        spayrowSPQS,
        SPQS,
        setSPQS,
        SPQSData,
        setSPQSData,
        ppaymenttermSPQS,
        setPpaymenttermSPQS,
        ppaymenttermDataSPQS,
        setPpaymenttermDataSPQS,
        spaymenttermSPQS,
        setSpaymenttermSPQS,
        spaymenttermDataSPQS,
        setSpaymenttermDataSPQS,
        qstoeditSP,
        setQstoeditSP,
        whdataSP,
        setWhdataSP,
      }}
    >
      {children}
    </SPQSContext.Provider>
  );
};

export default SPQSContext;
